import React, { useCallback, useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useStore } from "stores/connect";
import { Input } from "components/bootstrap";
import { Spinner } from "components/common";
import { NodesStore } from "stores/nodes/NodesStore";
const NodeOrGlobalSelect = ({ global = false, node = void 0, onChange }) => {
  const { t } = useTranslation("inputs");
  const { nodes } = useStore(NodesStore);
  const [globalState, setGlobal] = useState(global);
  const [nodeState, setNode] = useState(node);
  useEffect(() => {
    if (!node && nodes) {
      const nodeIds = Object.keys(nodes);
      if (nodeIds.length === 1) {
        onChange("node", nodeIds[0]);
        setNode(nodeIds[0]);
      }
    }
  }, [nodes]);
  const _onChangeGlobal = useCallback(
    (evt) => {
      const isGlobal = evt.target.checked;
      setGlobal(isGlobal);
      if (isGlobal) {
        setNode("placeholder");
        onChange("node", void 0);
      } else {
        onChange("node", nodeState);
      }
      onChange("global", isGlobal);
    },
    [onChange, nodeState, setNode, setGlobal]
  );
  const _onChangeNode = useCallback(
    (evt) => {
      setNode(evt.target.value);
      onChange("node", evt.target.value);
    },
    [setNode, onChange]
  );
  if (!nodes) {
    return /* @__PURE__ */ React.createElement(Spinner, null);
  }
  const options = Object.keys(nodes).map((nodeId) => /* @__PURE__ */ React.createElement("option", { key: nodeId, value: nodeId }, nodes[nodeId].short_node_id, " / ", nodes[nodeId].hostname));
  const nodeSelect = !globalState ? /* @__PURE__ */ React.createElement(
    Input,
    {
      id: "node-select",
      type: "select",
      label: t("node_select.node"),
      placeholder: t("node_select.select_node"),
      value: node,
      help: t("node_select.node_help"),
      onChange: _onChangeNode,
      required: true
    },
    /* @__PURE__ */ React.createElement("option", { key: "placeholder", value: "" }, t("node_select.select_node")),
    options
  ) : null;
  return /* @__PURE__ */ React.createElement("span", null, /* @__PURE__ */ React.createElement(
    Input,
    {
      id: "global-checkbox",
      type: "checkbox",
      label: t("node_select.global"),
      help: t("node_select.global_help"),
      checked: globalState,
      onChange: _onChangeGlobal
    }
  ), nodeSelect);
};
export default NodeOrGlobalSelect;
